import React from "react"
import { get, reject } from "lodash"

import { BaseTable } from "components/molecules/table"
import { tableColumns } from "config/table_columns"
import { APIResponse } from "redux/apis/types"
import { useTransferData } from "components/actions/symbolDetail"
import { Pagination } from "components/molecules/pagination"
import { checkIsSp } from "utils/util"
import { SpDetailTable } from "components/molecules/table/spTable"
import { useSelector } from "react-redux"

type TransferProps = {
  symbolDetail: APIResponse.Res
}

export const Transfer: React.FC<TransferProps> = props => {
  const symbol = get(props.symbolDetail, "Symbol")
  const isRefresh = useSelector(
    (state: { symbolDetail: { refresh: boolean } }) =>
      state.symbolDetail.refresh
  )
  const data = useTransferData(symbol, isRefresh)
  if (!data) return null
  const capitalData = get(data.capital, "ResultList", [])
  const transferData = get(data.transfer, "ResultList", [])
  const isSp = checkIsSp()
  return (
    <div className="panel-transfer">
      <div className="title-border-container">
        <div className="title-border">資本異動</div>
        {!isSp ? (
          <>
            <BaseTable
              className="table-striped"
              list={tableColumns.symbolDetail.capital.capital}
              data={capitalData}
            />
            {capitalData.length === 0 && (
              <Pagination
                list={[]}
                current={0}
                page={0}
                changePage={() => {}}
              />
            )}
          </>
        ) : (
          <SpDetailTable
            bodyList={tableColumns.symbolDetail.capital.capitalSp.body}
            data={capitalData}
          />
        )}
      </div>
      <div className="title-border-container">
        <div className="title-border">企業異動</div>
        {!isSp ? (
          <>
            <BaseTable
              className="table-striped"
              list={tableColumns.symbolDetail.capital.move}
              data={transferData}
            />
            {transferData.length === 0 && (
              <Pagination
                list={[]}
                current={0}
                page={0}
                changePage={() => {}}
              />
            )}
          </>
        ) : (
          <SpDetailTable
            bodyList={tableColumns.symbolDetail.capital.moveSp.body}
            data={transferData}
          />
        )}
      </div>
    </div>
  )
}
